import { useFormik } from "formik";
import { confirmAlert } from "react-confirm-alert";
import { Modal } from "react-bootstrap";
import { URL_LIST_ALL } from "../../configs/api";
import Axios from "axios";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import AlertErrorForm from "../../component/AlertErrorForm";

export default function ModalImport(props) {
    const { refresh, setRefresh, user } = props
    const [selectedFile, setSelectedFile] = useState(null);
    const [messageResult, setMessageResult] = useState([])
    const [listCampaign, setListCampaign] = useState([])

    const [showModalImport, setShowModalImport] = useState(false)

    const formImport = useFormik({
        initialValues: {},
        enableReinitialize: true,

        onSubmit: (values, { setSubmitting, resetForm }) => {

            if (selectedFile) {
                if (values.campaign_id) {


                    let formData = new FormData();
                    formData.append('file', selectedFile, selectedFile.name)
                    formData.append('type', 'banghang');
                    formData.append('name', 'datacustomers');
                    formData.append('campaign', values.campaign_id);
                    Axios.post(URL_LIST_ALL + 'upload', formData, {
                        headers: {
                            ...user.config?.headers, // thêm Authorization nếu có
                            "Content-Type": "multipart/form-data", // quan trọng
                        },
                    }).then(async (res) => {
                        setSubmitting(false);
                        if (res.data.status === "success") {
                            resetForm();
                            setMessageResult(res.data.message)
                            setRefresh(!refresh)
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch((err) => { setSubmitting(false); console.log(err) });
                } else {
                    setSubmitting(false);
                    alert("Vui lòng chọn Chiến dịch")
                }
            } else {
                setSubmitting(false);
                alert("Vui lòng chọn file")
            }
        },
    });

    useEffect(
        function () {
            let mounted = true;
            Axios.get(URL_LIST_ALL + "campaign?status=1", user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        if (mounted) {
                            setListCampaign(res.data.data);
                        }
                    } else console.log(res.data.message);
                })
                .catch((err) => console.log(err));
            return () => (mounted = false);

        }, [user]
    );

    return <>
        <button type="button" className="btn btn-sm btn-info ml-2" onClick={() => setShowModalImport(!showModalImport)}>Import</button>
        <Modal
            className="modal-customer-detail"
            show={showModalImport}
            onHide={() => setShowModalImport(false)}
            animation={true}
            size="md"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Import khách hàng
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="new-added-form" method="post" onSubmit={formImport.handleSubmit}>
                    <div className="row">
                        <div className="col-12">
                            <label>Bạn có thể tải mẫu tại đây</label>
                            <a target="_blank" className="ml-2 btn btn-sm btn-primary" href="https://docs.google.com/spreadsheets/d/1tI3slOUFn8TRviSSHApiicMtZtdVX3o_5OO9POdmM94/edit?usp=sharing">
                                Tải mẫu
                            </a>
                        </div>
                        <div className="col-12 mg-t-8">
                            <div className="my-3">
                                <input id="formFile" className="form-control form-file" type="file" onChange={(e) => setSelectedFile(e.target.files[0])} accept=".xlsx,.xls"></input>
                            </div>
                            <div className="my-3">
                                <select className="form-select form-control form-control-sm height32" {...formImport.getFieldProps("campaign_id")}>
                                    <option value="0" >Chọn chiến dịch</option>
                                    {listCampaign.map((item) => <option value={item.id} key={item.id} >{item.title}</option>)}
                                </select>
                            </div>
                            <AlertErrorForm formik={formImport} name="campaign_id"></AlertErrorForm>
                            {messageResult && messageResult.map((it, j) => <p key={j}>{it}</p>)}
                            <div className="mt-3">
                                <button type="submit" disabled={formImport.isSubmitting} className="btn btn-success mr-2">{formImport.isSubmitting ? <div className="loader"></div> : <>Upload</>}</button>
                                <button type="reset" onClick={formImport.resetForm} className="btn btn-warning">Nhập lại</button>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    </>
}